import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-668f7612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "row",
  style: {"border-radius":"25px","top":"50px"}
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = {
  key: 0,
  class: "card-body-custom"
}
const _hoisted_5 = {
  style: {"position":"relative","height":"50px"},
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/icons/chevron-left-circle-bold.svg",
  style: {"width":"25px"},
  alt: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px","font-weight":"600"} }, "Transaction Detail ", -1))
const _hoisted_9 = { class: "body__card__header" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body__card__title" }, "Profit & Loss Order", -1))
const _hoisted_11 = { class: "py-10 px-8 card__content__title" }
const _hoisted_12 = { class: "px-2" }
const _hoisted_13 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Manager", -1))
const _hoisted_15 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Weserve", -1))
const _hoisted_17 = { class: "mt-5 px-3" }
const _hoisted_18 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Manager", -1))
const _hoisted_20 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Weserve", -1))
const _hoisted_22 = { class: "mt-5 px-3" }
const _hoisted_23 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Manager", -1))
const _hoisted_25 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Weserve", -1))
const _hoisted_27 = {
  class: "mt-5 px-3",
  style: {"color":"red"}
}
const _hoisted_28 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Manager", -1))
const _hoisted_30 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Weserve", -1))
const _hoisted_32 = {
  class: "mt-5 p-3",
  style: {"background":"#fffbd9 0% 0% no-repeat padding-box","border":"1px solid #ffd600","border-radius":"4px","opacity":"1"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Summary", -1))
const _hoisted_34 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Manager", -1))
const _hoisted_36 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Weserve", -1))
const _hoisted_38 = { class: "body__card__header" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body__card__title" }, "Profit & Loss Rider", -1))
const _hoisted_40 = { class: "py-10 px-8 card__content__title" }
const _hoisted_41 = { class: "px-2" }
const _hoisted_42 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Manager", -1))
const _hoisted_44 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Weserve", -1))
const _hoisted_46 = { class: "mt-5 px-3" }
const _hoisted_47 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Manager", -1))
const _hoisted_49 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Weserve", -1))
const _hoisted_51 = {
  class: "mt-5 px-3",
  style: {"color":"red"}
}
const _hoisted_52 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Manager", -1))
const _hoisted_54 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Weserve", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-5 px-3",
  style: {"padding":"38px"}
}, null, -1))
const _hoisted_57 = {
  class: "mt-5 p-3",
  style: {"background":"#fffbd9 0% 0% no-repeat padding-box","border":"1px solid #ffd600","border-radius":"4px","opacity":"1"}
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Summary", -1))
const _hoisted_59 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Manager", -1))
const _hoisted_61 = { class: "d-flex justify-content-between mt-2 ms-3" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "• Weserve", -1))
const _hoisted_63 = {
  class: "body__card__header",
  style: {"margin-top":"20px","margin-bottom":"20px","padding":"15px","background":"#fffbd9 0% 0% no-repeat padding-box","border":"1px solid #ffd600","border-radius":"4px","opacity":"1"}
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "card__content__title",
    style: {"font-size":"16px","font-weight":"500"}
  }, "Summary Profit & Loss")
], -1))
const _hoisted_65 = {
  class: "mb-5",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Manager", -1))
const _hoisted_67 = { class: "ms-2 card__content__value" }
const _hoisted_68 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Weserve", -1))
const _hoisted_70 = { class: "ms-2 card__content__value" }
const _hoisted_71 = { class: "body__card__header" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body__card__title" }, "Transaction Order", -1))
const _hoisted_73 = { class: "p-10" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Code :", -1))
const _hoisted_75 = { class: "ms-2 card__content__value" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Type :", -1))
const _hoisted_77 = { class: "ms-2 card__content__value" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Description :", -1))
const _hoisted_79 = { class: "ms-2 card__content__value" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Credit :", -1))
const _hoisted_81 = { class: "ms-2 card__content__value" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Date/Time :", -1))
const _hoisted_83 = { class: "ms-2 card__content__value" }
const _hoisted_84 = { class: "body__card__header" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body__card__title" }, "Rider Information", -1))
const _hoisted_86 = { class: "p-10" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Current rider :", -1))
const _hoisted_88 = { class: "ms-2 card__content__value" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Tel. :", -1))
const _hoisted_90 = { class: "ms-2 card__content__value" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title pe-2" }, "Area :", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Vehicle type :", -1))
const _hoisted_93 = { class: "ms-2 card__content__value" }
const _hoisted_94 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_95 = { class: "body__card__header" }
const _hoisted_96 = { class: "body__card__title" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-center",
  style: {"font-size":"16px","font-weight":"500"}
}, " Order Information ", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Status :", -1))
const _hoisted_100 = { class: "ms-2 card__content__value" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Order start date :", -1))
const _hoisted_102 = { class: "ms-2 card__content__value" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Order start time :", -1))
const _hoisted_104 = { class: "ms-2 card__content__value" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Order end date :", -1))
const _hoisted_106 = { class: "ms-2 card__content__value" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Order end time :", -1))
const _hoisted_108 = { class: "ms-2 card__content__value" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Pay by :", -1))
const _hoisted_110 = { class: "ms-2 card__content__value" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Order area :", -1))
const _hoisted_112 = { class: "ms-2 card__content__value" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Note to rider :", -1))
const _hoisted_114 = { class: "ms-2 card__content__value" }
const _hoisted_115 = {
  style: {"background-color":"#f3f5f7"},
  class: "p-5 mt-5"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Store name :", -1))
const _hoisted_117 = { class: "ms-2 card__content__value" }
const _hoisted_118 = { class: "mt-3" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Store Tel. :", -1))
const _hoisted_120 = { class: "mt-3" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Address :", -1))
const _hoisted_122 = { class: "ms-2 card__content__value" }
const _hoisted_123 = { class: "mt-3" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Note to store :", -1))
const _hoisted_125 = { class: "ms-2 card__content__value" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-center",
  style: {"font-size":"16px","font-weight":"500"}
}, " Customer Information ", -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Name :", -1))
const _hoisted_129 = { class: "ms-2 card__content__value" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Tel. :", -1))
const _hoisted_131 = { class: "ms-2 card__content__value" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "E-mail :", -1))
const _hoisted_133 = { class: "ms-2 card__content__value" }
const _hoisted_134 = {
  style: {"background-color":"#f3f5f7"},
  class: "p-5 mt-5"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Address :", -1))
const _hoisted_136 = { class: "ms-2 card__content__value" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Tel. :", -1))
const _hoisted_138 = { class: "ms-2 card__content__value" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Distance from store :", -1))
const _hoisted_140 = { class: "ms-2 card__content__value" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "latitude :", -1))
const _hoisted_142 = { class: "ms-2 card__content__value" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "longitude :", -1))
const _hoisted_144 = { class: "ms-2 card__content__value" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Place note :", -1))
const _hoisted_146 = { class: "ms-2 card__content__value" }
const _hoisted_147 = { class: "d-flex justify-content-center mt-10" }
const _hoisted_148 = ["href"]
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#333333","color":"white","border-radius":"5px","height":"45px","font-size":"16px","font-weight":"bold","display":"flex","justify-content":"center","align-items":"center","padding":"0px 30px","cursor":"pointer"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-geo-alt-fill",
    style: {"color":"white","font-size":"20px"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, " MAP DESTINATION")
], -1))
const _hoisted_150 = [
  _hoisted_149
]
const _hoisted_151 = { class: "body__card__header mt-10" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body__card__title" }, "Order Detail Product", -1))
const _hoisted_153 = { class: "p-10" }
const _hoisted_154 = { class: "table gs-7 gy-7 gx-7" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold fs-5 text-gray-800 border-bottom border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", null, "No."),
    /*#__PURE__*/_createElementVNode("th", null, "Store"),
    /*#__PURE__*/_createElementVNode("th", null, "Product"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Price"),
    /*#__PURE__*/_createElementVNode("th", null, "Option"),
    /*#__PURE__*/_createElementVNode("th", null, "Note"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Price")
  ])
], -1))
const _hoisted_156 = { class: "text-center" }
const _hoisted_157 = { key: 0 }
const _hoisted_158 = { key: 1 }
const _hoisted_159 = {
  class: "card__content__title",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_160 = { style: {"width":"50vw"} }
const _hoisted_161 = {
  style: {"display":"flex","justify-content":"space-between"},
  class: "mt-3"
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Item price", -1))
const _hoisted_163 = {
  style: {"display":"flex","justify-content":"space-between"},
  class: "mt-3"
}
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Transport price", -1))
const _hoisted_165 = {
  style: {"display":"flex","justify-content":"space-between"},
  class: "mt-3"
}
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Store package transport price", -1))
const _hoisted_167 = {
  style: {"display":"flex","justify-content":"space-between"},
  class: "mt-3"
}
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Extra time transfer", -1))
const _hoisted_169 = {
  style: {"display":"flex","justify-content":"space-between"},
  class: "mt-3"
}
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Vat", -1))
const _hoisted_171 = {
  style: {"display":"flex","justify-content":"space-between"},
  class: "mt-3"
}
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Service charge", -1))
const _hoisted_173 = {
  style: {"display":"flex","justify-content":"space-between","color":"red"},
  class: "mt-3"
}
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Discount", -1))
const _hoisted_175 = {
  style: {"display":"flex","justify-content":"space-between","color":"#4caf50"},
  class: "mt-3"
}
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Net Price", -1))
const _hoisted_177 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_178 = { class: "body__card__header" }
const _hoisted_179 = { class: "body__card__title" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-center",
  style: {"font-size":"16px","font-weight":"500"}
}, " Order Information ", -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Status :", -1))
const _hoisted_183 = { class: "ms-2 card__content__value" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Order coming date :", -1))
const _hoisted_185 = { class: "ms-2 card__content__value" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Order coming time :", -1))
const _hoisted_187 = { class: "ms-2 card__content__value" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Transferred date :", -1))
const _hoisted_189 = { class: "ms-2 card__content__value" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Transferred time :", -1))
const _hoisted_191 = { class: "ms-2 card__content__value" }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Pay by :", -1))
const _hoisted_193 = { class: "ms-2 card__content__value" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Note to rider :", -1))
const _hoisted_195 = { class: "ms-2 card__content__value" }
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-center",
  style: {"font-size":"16px","font-weight":"500"}
}, " Customer Information ", -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Name :", -1))
const _hoisted_199 = { class: "ms-2 card__content__value" }
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Tel. :", -1))
const _hoisted_201 = { class: "ms-2 card__content__value" }
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "E-mail :", -1))
const _hoisted_203 = { class: "ms-2 card__content__value" }
const _hoisted_204 = { class: "d-flex justify-content-center mt-10" }
const _hoisted_205 = ["href"]
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#333333","color":"white","border-radius":"5px","height":"45px","font-size":"16px","font-weight":"bold","display":"flex","justify-content":"center","align-items":"center","padding":"0px 30px","cursor":"pointer"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-geo-alt-fill",
    style: {"color":"white","font-size":"20px"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, " MAP DESTINATION")
], -1))
const _hoisted_207 = [
  _hoisted_206
]
const _hoisted_208 = {
  class: "text-center",
  style: {"font-size":"16px","font-weight":"500"}
}
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_210 = {
  style: {"display":"flex","align-items":"center","font-size":"14px"},
  class: "mt-5"
}
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/pin_location.png",
    alt: "",
    style: {"width":"15px"}
  })
], -1))
const _hoisted_212 = {
  style: {"background-color":"#f3f5f7"},
  class: "p-5 mt-5"
}
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Full name :", -1))
const _hoisted_214 = { class: "ms-2 card__content__value" }
const _hoisted_215 = { class: "mt-3" }
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Tel. :", -1))
const _hoisted_217 = { class: "ms-2 card__content__value" }
const _hoisted_218 = { class: "mt-3" }
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__content__title" }, "Note :", -1))
const _hoisted_220 = { class: "ms-2 card__content__value" }
const _hoisted_221 = { class: "body__card__header mt-10" }
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body__card__title" }, "Price information", -1))
const _hoisted_223 = {
  class: "p-10 card__content__title",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_224 = { style: {"width":"50vw"} }
const _hoisted_225 = {
  style: {"display":"flex","justify-content":"space-between","color":"#ffa700"},
  class: "mt-3"
}
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ระยะทางรวม", -1))
const _hoisted_227 = {
  style: {"display":"flex","justify-content":"space-between"},
  class: "mt-3"
}
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Transportation", -1))
const _hoisted_229 = {
  style: {"display":"flex","justify-content":"space-between"},
  class: "mt-3"
}
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add on", -1))
const _hoisted_231 = {
  style: {"display":"flex","justify-content":"space-between"},
  class: "mt-3"
}
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Extra point", -1))
const _hoisted_233 = {
  style: {"display":"flex","justify-content":"space-between","color":"red"},
  class: "mt-3"
}
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Discount", -1))
const _hoisted_235 = {
  style: {"display":"flex","justify-content":"space-between","color":"#4caf50"},
  class: "mt-3"
}
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Net Price", -1))
const _hoisted_237 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_WalletTransactionInvoiceVue = _resolveComponent("WalletTransactionInvoiceVue")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.isLoading == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back())),
                        class: "btn btn-active-white",
                        style: {"position":"absolute","left":"0px"}
                      }, _hoisted_7),
                      _hoisted_8
                    ]),
                    _createVNode(_component_el_row, {
                      justify: "space-around",
                      class: "mt-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 24,
                          sm: 11
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _hoisted_10,
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", null, " Gross Profit Price ( " + _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_profit_and_loss
                            .data_profit_and_loss_order.GP.total) + " CREDIT ) ", 1),
                                  _createElementVNode("div", _hoisted_13, [
                                    _hoisted_14,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_order.GP.manager >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.GP.manager}`
                              : `-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.GP.manager}`) + " CREDIT", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_15, [
                                    _hoisted_16,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_order.GP.weserve >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.GP.weserve}`
                              : `-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.GP.weserve}`) + " CREDIT", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("div", null, " Extra Transport Price ( " + _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_profit_and_loss
                            .data_profit_and_loss_order.extra_transport.total) + " CREDIT ) ", 1),
                                  _createElementVNode("div", _hoisted_18, [
                                    _hoisted_19,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_order.extra_transport
                              .manager >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.extra_transport.manager}`
                              : `-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.extra_transport.manager}`) + " CREDIT", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_20, [
                                    _hoisted_21,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_order.extra_transport
                              .weserve >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.extra_transport.weserve}`
                              : `-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.extra_transport.weserve}`) + " CREDIT", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", null, " Small Order Price ( " + _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_profit_and_loss
                            .data_profit_and_loss_order.small_order.total) + " CREDIT ) ", 1),
                                  _createElementVNode("div", _hoisted_23, [
                                    _hoisted_24,
                                    _createElementVNode("span", null, _toDisplayString(`+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.small_order.manager}`) + " CREDIT", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _hoisted_26,
                                    _createElementVNode("span", null, _toDisplayString(`+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.small_order.weserve}`) + " CREDIT", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", null, " Promotion Discount Price ( " + _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_profit_and_loss
                            .data_profit_and_loss_order.promotion.total) + " CREDIT ) ", 1),
                                  _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createElementVNode("span", null, _toDisplayString(`-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.promotion.manager}`) + " CREDIT", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _hoisted_31,
                                    _createElementVNode("span", null, _toDisplayString(`-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.promotion.weserve}`) + " CREDIT", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _hoisted_33,
                                  _createElementVNode("div", _hoisted_34, [
                                    _hoisted_35,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_order.summary_order
                              .manager >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.summary_order.manager}`
                              : `${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.summary_order.manager}`) + " CREDIT", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    _hoisted_37,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_order.summary_order
                              .weserve >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.summary_order.weserve}`
                              : `${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.summary_order.weserve}`) + " CREDIT", 1)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          span: 24,
                          sm: 11
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_38, [
                              _hoisted_39,
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", null, " Additional Fee Price ( " + _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_profit_and_loss
                            .data_profit_and_loss_rider
                            .fee_delivery_differentail.total) + " CREDIT ) ", 1),
                                  _createElementVNode("div", _hoisted_42, [
                                    _hoisted_43,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_rider
                              .fee_delivery_differentail.manager >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery_differentail.manager}`
                              : `-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.fee_delivery_differentail.manager}`) + " CREDIT", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_44, [
                                    _hoisted_45,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_rider
                              .fee_delivery_differentail.weserve >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery_differentail.weserve}`
                              : `-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery_differentail.weserve}`) + " CREDIT", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", null, " Fee Delivery Price ( " + _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_profit_and_loss
                            .data_profit_and_loss_rider.fee_delivery.total) + " CREDIT ) ", 1),
                                  _createElementVNode("div", _hoisted_47, [
                                    _hoisted_48,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_rider.fee_delivery
                              .manager >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery.manager}`
                              : `-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery.manager}`) + " CREDIT", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_49, [
                                    _hoisted_50,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_rider.fee_delivery
                              .weserve >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery.weserve}`
                              : `-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery.weserve}`) + " CREDIT", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", null, " Guarantee Fee Price ( " + _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_profit_and_loss
                            .data_profit_and_loss_rider.guarantee_fee.total) + " CREDIT ) ", 1),
                                  _createElementVNode("div", _hoisted_52, [
                                    _hoisted_53,
                                    _createElementVNode("span", null, _toDisplayString(`${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.guarantee_fee.manager}`) + " CREDIT", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _hoisted_55,
                                    _createElementVNode("span", null, _toDisplayString(`${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.guarantee_fee.weserve}`) + " CREDIT", 1)
                                  ])
                                ]),
                                _hoisted_56,
                                _createElementVNode("div", _hoisted_57, [
                                  _hoisted_58,
                                  _createElementVNode("div", _hoisted_59, [
                                    _hoisted_60,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_rider.summary_rider
                              .manager >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.summary_rider.manager}`
                              : `${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.summary_rider.manager}`) + " CREDIT", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_61, [
                                    _hoisted_62,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                              .transaction_partner_profit_and_loss
                              .data_profit_and_loss_rider.summary_rider
                              .weserve >= 0
                              ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.summary_rider.weserve}`
                              : `${_ctx.walletTransactionDetail.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.summary_rider.weserve}`) + " CREDIT", 1)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: 24,
                            sm: 6
                          }, {
                            default: _withCtx(() => [
                              _hoisted_64
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { class: "my-5" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: 20,
                            sm: 20
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_65, [
                                _hoisted_66,
                                _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                          .transaction_partner_profit_and_loss
                          .summary_profit_and_loss.manager) + " CREDIT", 1)
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _hoisted_69,
                                _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                          .transaction_partner_profit_and_loss
                          .summary_profit_and_loss.weserve) + " CREDIT", 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_el_row, { style: {"justify-content":"space-between"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 24,
                          sm: 11
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_71, [
                              _hoisted_72,
                              _createElementVNode("div", _hoisted_73, [
                                _createVNode(_component_el_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _hoisted_74,
                                        _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_order_code), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _hoisted_76,
                                        _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_type), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 24,
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_78,
                                        _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_description || "-"), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 12,
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_80,
                                        _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.walletTransactionDetail.transaction_order
                            .transaction_partner_we_credit >= 0
                            ? `+${_ctx.walletTransactionDetail.transaction_order.transaction_partner_we_credit}`
                            : `-${_ctx.walletTransactionDetail.transaction_order.transaction_partner_we_credit}`), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 12,
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_82,
                                        _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.moment(
                            _ctx.walletTransactionDetail.transaction_order.create_at
                          ).format("YYYY-MM-DD HH:mm")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          span: 24,
                          sm: 11
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_84, [
                              _hoisted_85,
                              _createElementVNode("div", _hoisted_86, [
                                _createVNode(_component_el_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _hoisted_87,
                                        _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.walletTransactionDetail.rider_information.rider_name), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _hoisted_89,
                                        _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.walletTransactionDetail.rider_information.rider_tel), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 12,
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_91,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walletTransactionDetail.rider_information
                            .rider_area, (rider_area, rider_area_index) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            class: "card__content__value",
                                            key: rider_area_index
                                          }, _toDisplayString((rider_area_index == 0 ? "" : ", ") +
                            rider_area.district_name_th), 1))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 12,
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_92,
                                        _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.walletTransactionDetail.rider_information
                            .rider_vehicle_type), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.walletTransactionDetail.order.order_type == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("div", _hoisted_96, " Detail order #" + _toDisplayString(_ctx.walletTransactionDetail.order.order_code), 1),
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: 24,
                                  sm: 12,
                                  class: "p-10"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_97,
                                    _hoisted_98,
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _hoisted_99,
                                            _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.walletTransactionDetail.order.order_status == 1
                            ? "Order made"
                            : _ctx.walletTransactionDetail.order.order_status == 2
                            ? "Inqueue"
                            : _ctx.walletTransactionDetail.order.order_status == 3
                            ? "Cooking"
                            : _ctx.walletTransactionDetail.order.order_status == 4
                            ? "Ready to pick"
                            : _ctx.walletTransactionDetail.order.order_status == 5
                            ? "On the way"
                            : _ctx.walletTransactionDetail.order.order_status == 6
                            ? "Completed"
                            : _ctx.walletTransactionDetail.order.order_status == 7
                            ? "Canceled"
                            : "OTher"), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 12,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_101,
                                            _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.moment(
                            _ctx.walletTransactionDetail.order.order_time_start
                          ).format("YYYY-MM-DD")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 12,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_103,
                                            _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.moment(
                            _ctx.walletTransactionDetail.order.order_time_start
                          ).format("HH:mm")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 12,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_105,
                                            _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.moment(
                            _ctx.walletTransactionDetail.order.order_time_end
                          ).format("YYYY-MM-DD")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 12,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_107,
                                            _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.moment(
                            _ctx.walletTransactionDetail.order.order_time_end
                          ).format("HH:mm")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 12,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_109,
                                            _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.walletTransactionDetail.order.order_payment_type == 1
                            ? "COD"
                            : _ctx.walletTransactionDetail.order
                                .order_payment_type == 2
                            ? "Credit card"
                            : _ctx.walletTransactionDetail.order
                                .order_payment_type == 3
                            ? "PromptPay"
                            : _ctx.walletTransactionDetail.order
                                .order_payment_type == 4
                            ? "COIN"
                            : "Other"), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 12,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_111,
                                            _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.walletTransactionDetail.order.order_district_name), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_113,
                                            _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.walletTransactionDetail.order.order_transfer_note ||
                          "-"), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_115, [
                                      _createElementVNode("div", null, [
                                        _hoisted_116,
                                        _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.walletTransactionDetail.order.order_store
                            .store_name_th), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_118, [
                                        _hoisted_119,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walletTransactionDetail
                            .order.order_store.store_tel, (store_tel, index) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            class: "ms-2 card__content__value",
                                            key: index
                                          }, _toDisplayString((index == 0 ? "" : ", ") + `${store_tel.tel}`), 1))
                                        }), 128))
                                      ]),
                                      _createElementVNode("div", _hoisted_120, [
                                        _hoisted_121,
                                        _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.walletTransactionDetail.order.order_store
                            .store_address_th), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_123, [
                                        _hoisted_124,
                                        _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.walletTransactionDetail.order.order_store
                            .store_note || "-"), 1)
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  span: 24,
                                  sm: 12,
                                  class: "p-10"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_126,
                                    _hoisted_127,
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          sm: 12,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                              _hoisted_128,
                                              _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.walletTransactionDetail.order
                              .order_customer_full_name), 1)
                                            ])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          sm: 12,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                              _hoisted_130,
                                              _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.walletTransactionDetail.order.order_customer
                              .user_country_tel +
                            _ctx.walletTransactionDetail.order.order_customer
                              .user_tel), 1)
                                            ])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          sm: 12,
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                              _hoisted_132,
                                              _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.walletTransactionDetail.order.order_customer
                              .user_email || "-"), 1)
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_134, [
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 24 }, {
                                            default: _withCtx(() => [
                                              _hoisted_135,
                                              _createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.walletTransactionDetail.order.order_customer_address
                              .user_address_text), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 24,
                                            sm: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_137,
                                              _createElementVNode("span", _hoisted_138, "0" + _toDisplayString(_ctx.walletTransactionDetail.order
                                .order_customer_address.user_address_contact_tel), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 24,
                                            sm: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_139,
                                              _createElementVNode("span", _hoisted_140, _toDisplayString(_ctx.walletTransactionDetail.order.order_distance) + " m.", 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 24,
                                            sm: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_141,
                                              _createElementVNode("span", _hoisted_142, _toDisplayString(_ctx.walletTransactionDetail.order.order_customer_address
                              .user_address_lat), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 24,
                                            sm: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_143,
                                              _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.walletTransactionDetail.order.order_customer_address
                              .user_address_long), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 24,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_145,
                                              _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.walletTransactionDetail.order.order_customer_address
                              .user_address_note || "-"), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_147, [
                                      _createElementVNode("a", {
                                        target: "_blank",
                                        href: `https://www.google.co.th/maps/dir/${_ctx.walletTransactionDetail.order.order_store.store_lat},${_ctx.walletTransactionDetail.order.order_store.store_long}/${_ctx.walletTransactionDetail.order.order_customer_address.user_address_lat},${_ctx.walletTransactionDetail.order.order_customer_address.user_address_long}/data=!4m2!4m1!3e0`
                                      }, _hoisted_150, 8, _hoisted_148)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_151, [
                            _hoisted_152,
                            _createElementVNode("div", _hoisted_153, [
                              _createElementVNode("table", _hoisted_154, [
                                _hoisted_155,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walletTransactionDetail.order.order_detail, (product, productIndex) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: productIndex }, [
                                      _createElementVNode("td", null, _toDisplayString(productIndex + 1), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_store
                              .store_name_th), 1),
                                      _createElementVNode("td", null, _toDisplayString(product.order_detail_product.product_name_th), 1),
                                      _createElementVNode("td", _hoisted_156, _toDisplayString(product.order_detail_amount), 1),
                                      _createElementVNode("td", null, _toDisplayString(product.order_detail_product_seller_price), 1),
                                      (product.order_detail_order_option.length > 0)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_157, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.order_detail_order_option, (optionItem, optionIndex) => {
                                              return (_openBlock(), _createElementBlock("div", { key: optionIndex }, [
                                                _createElementVNode("b", null, _toDisplayString(optionItem.order_option_option_choice
                                  .option_name_th), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionItem
                                .order_option_option_choice.option_choice, (choiceItem, choiceIndex) => {
                                                  return (_openBlock(), _createElementBlock("li", { key: choiceIndex }, _toDisplayString(choiceItem.choice_name_th), 1))
                                                }), 128))
                                              ]))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_158, "-")),
                                      _createElementVNode("td", null, _toDisplayString(product.order_detail_product.product_note || "-"), 1),
                                      _createElementVNode("td", null, _toDisplayString(product.order_detail_total_product_price), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_159, [
                                _createElementVNode("div", _hoisted_160, [
                                  _createElementVNode("div", _hoisted_161, [
                                    _hoisted_162,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_total_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_163, [
                                    _hoisted_164,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_transfer_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_165, [
                                    _hoisted_166,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order
                              .order_package_extra_transport_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_167, [
                                    _hoisted_168,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order
                              .order_transfer_extra_time_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_169, [
                                    _hoisted_170,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_vat_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_171, [
                                    _hoisted_172,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order
                              .order_service_charge_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_173, [
                                    _hoisted_174,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order
                              .order_total_discount_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_175, [
                                    _hoisted_176,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_net_price) + " THB", 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : (_ctx.walletTransactionDetail.order.order_type == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                            _createElementVNode("div", _hoisted_178, [
                              _createElementVNode("div", _hoisted_179, " Detail Messenger Order #" + _toDisplayString(_ctx.walletTransactionDetail.order.order_code), 1),
                              _createVNode(_component_el_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    span: 24,
                                    sm: 12,
                                    class: "p-10"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_180,
                                      _hoisted_181,
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 24 }, {
                                            default: _withCtx(() => [
                                              _hoisted_182,
                                              _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.walletTransactionDetail.order.order_status == 1
                            ? "Order made"
                            : _ctx.walletTransactionDetail.order.order_status == 2
                            ? "Inqueue"
                            : _ctx.walletTransactionDetail.order.order_status == 3
                            ? "Cooking"
                            : _ctx.walletTransactionDetail.order.order_status == 4
                            ? "Ready to pick"
                            : _ctx.walletTransactionDetail.order.order_status == 5
                            ? "On the way"
                            : _ctx.walletTransactionDetail.order.order_status == 6
                            ? "Completed"
                            : _ctx.walletTransactionDetail.order.order_status == 7
                            ? "Canceled"
                            : "OTher"), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_184,
                                              _createElementVNode("span", _hoisted_185, _toDisplayString(_ctx.moment(
                            _ctx.walletTransactionDetail.order.order_time_start
                          ).format("YYYY-MM-DD")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_186,
                                              _createElementVNode("span", _hoisted_187, _toDisplayString(_ctx.moment(
                            _ctx.walletTransactionDetail.order.order_time_start
                          ).format("HH:mm")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_188,
                                              _createElementVNode("span", _hoisted_189, _toDisplayString(_ctx.moment(
                            _ctx.walletTransactionDetail.order.order_time_end
                          ).format("YYYY-MM-DD")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_190,
                                              _createElementVNode("span", _hoisted_191, _toDisplayString(_ctx.moment(
                            _ctx.walletTransactionDetail.order.order_time_end
                          ).format("HH:mm")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_192,
                                              _createElementVNode("span", _hoisted_193, _toDisplayString(_ctx.walletTransactionDetail.order.order_payment_type == 1
                            ? "COD"
                            : _ctx.walletTransactionDetail.order
                                .order_payment_type == 2
                            ? "Credit card"
                            : _ctx.walletTransactionDetail.order
                                .order_payment_type == 3
                            ? "PromptPay"
                            : _ctx.walletTransactionDetail.order
                                .order_payment_type == 4
                            ? "COIN"
                            : "Other"), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 24,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_194,
                                              _createElementVNode("span", _hoisted_195, _toDisplayString(_ctx.walletTransactionDetail.order.order_transfer_note ||
                          "-"), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    span: 24,
                                    sm: 12,
                                    class: "p-10"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_196,
                                      _hoisted_197,
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, {
                                            span: 24,
                                            sm: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", null, [
                                                _hoisted_198,
                                                _createElementVNode("span", _hoisted_199, _toDisplayString(_ctx.walletTransactionDetail.order
                              .order_customer_full_name), 1)
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 24,
                                            sm: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", null, [
                                                _hoisted_200,
                                                _createElementVNode("span", _hoisted_201, _toDisplayString(_ctx.walletTransactionDetail.order.order_customer
                              .user_country_tel +
                            _ctx.walletTransactionDetail.order.order_customer
                              .user_tel), 1)
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, {
                                            span: 24,
                                            sm: 12,
                                            class: "mt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", null, [
                                                _hoisted_202,
                                                _createElementVNode("span", _hoisted_203, _toDisplayString(_ctx.walletTransactionDetail.order.order_customer
                              .user_email || "-"), 1)
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_204, [
                                        _createElementVNode("a", {
                                          target: "_blank",
                                          href: `https://www.google.co.th/maps/dir/${_ctx.extractArrayString(
                          _ctx.walletTransactionDetail.order.order_points
                        )}data=!4m2!4m1!3e0`
                                        }, _hoisted_207, 8, _hoisted_205)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    span: 24,
                                    sm: 12,
                                    class: "p-10"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_208, " Destination Information (" + _toDisplayString(_ctx.walletTransactionDetail.order.order_points.length) + " positions) ", 1),
                                      _hoisted_209,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walletTransactionDetail.order
                        .order_points, (n, i) => {
                                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                                          _createElementVNode("div", _hoisted_210, [
                                            _hoisted_211,
                                            _createTextVNode(" " + _toDisplayString(i + 1) + ": " + _toDisplayString(n.order_point_address), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_212, [
                                            _createElementVNode("div", null, [
                                              _hoisted_213,
                                              _createElementVNode("span", _hoisted_214, _toDisplayString(n.order_point_to || "-"), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_215, [
                                              _hoisted_216,
                                              _createElementVNode("span", _hoisted_217, _toDisplayString(n.order_point_list_tel || "-"), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_218, [
                                              _hoisted_219,
                                              _createElementVNode("span", _hoisted_220, _toDisplayString(n.order_point_remark || "-"), 1)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_221, [
                              _hoisted_222,
                              _createElementVNode("div", _hoisted_223, [
                                _createElementVNode("div", _hoisted_224, [
                                  _createElementVNode("div", _hoisted_225, [
                                    _hoisted_226,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_points.reduce(
                            function (previousValue, currentValue) {
                              return (
                                previousValue +
                                parseFloat(currentValue.order_point_distance)
                              );
                            },
                            0
                          )) + "km", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_227, [
                                    _hoisted_228,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_transfer_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_229, [
                                    _hoisted_230,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_total_addon_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_231, [
                                    _hoisted_232,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_store_extra_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_233, [
                                    _hoisted_234,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order
                            .order_total_discount_price) + " THB", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_235, [
                                    _hoisted_236,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.walletTransactionDetail.order.order_net_price) + " THB", 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_237, [
          _createVNode(_component_WalletTransactionInvoiceVue)
        ]))
  ]))
}